<template>
    <div class="alert-box" v-show="alertData.isAlert">
        <div class="alert-modal-mask"></div>
        <div class="alert-box-target">
            <div class="box">
                <p class="title" v-html="alertData.title"></p>
                <p class="title" v-if="alertData.subhead">{{alertData.subhead}}</p>
                <p class="message" v-show="alertData.message">{{alertData.message}}</p>
                <div class="btn double-btn flex_box text_c " v-show="alertData.btnType == 'double'">
                    <a class="btn-cancel flex_1" @click="$emit('closeDialog', false);">{{cancelText}}</a>
                    <a v-if="alertData.phoneNumber" :href="'tel:' + alertData.phoneNumber" :class="alertData.class"  class="btn-confirm flex_1" @click="$emit('closeDialog', true);">{{confirmText}}</a>
                    <a v-if="alertData.email"
                       href="javascript:;"
                       class="btn-confirm flex_1"
                       v-clipboard:copy="alertData.email"
                       v-clipboard:success="onCopy"
                       v-clipboard:error="onError"
                    >{{confirmText}}</a>
                    <a v-else :class="alertData.class" class="btn-confirm flex_1" @click="$emit('closeDialog', true);">{{confirmText}}</a>
                </div>
                <div class="btn single-btn" v-show="alertData.btnType == 'single'">
                    <a class="btn-confirm" @click="$emit('closeDialog', false);">{{confirmText}}</a>
                </div>
                <div class="btn " v-show="alertData.btnType == 'none'"></div>
            </div>
        </div>
    </div>
</template>

<script>

    import { Toast } from 'mint-ui';

    export default {
        name: 'Alert',
        props: ['alertData'],
        data: function () {
            return {
                confirmText: '确定',
                cancelText: "取消"
            }
        },
        mounted() {
            if(this.alertData.confirmText)
                this.confirmText = this.alertData.confirmText;

            if(this.alertData.cancelText)
                this.cancelText = this.alertData.cancelText;
        },
        watch: {},
        methods: {
            onCopy() {
                Toast({
                    message: `邮件地址已复制`,
                    position: 'top',
                    duration: 2000
                });
                this.$emit('closeDialog', true);
            },
            onError(){
                Toast({
                    message: `邮件地址复制失败`,
                    position: 'top',
                    duration: 5000
                });
            }
        },
    }


</script>

<style lang="scss" scoped>

    .alert-box {
        //padding: 10px;
        position: relative;

        .alert-modal-mask {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0.8;
            background: #000000;
            z-index: 11;
            transition: all 0.3s ease-in-out;
            visibility: visible;
        }

        .alert-box-target {
            position: fixed;
            top: 50%;
            left: 50%;
            -webkit-transform: translate3d(-50%, -50%, 0);
            transform: translate3d(-50%, -50%, 0);
            background-color: #ffffff;
            width: 343px;
            height: 200px;
            border-radius: 3px;
            font-size: 16px;
            -webkit-user-select: none;
            overflow: hidden;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            -webkit-transition: .2s;
            transition: .2s;
            z-index: 12;
        }

        .box {
            padding: 50px 16px 20px 16px;
        }

        .title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000000;
            letter-spacing: 0;
            text-align: center;
            line-height: 24px;
        }

        .message {
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #7980b0;
            letter-spacing: 0;
            text-align: center;
            line-height: 22px;
        }

        .btn {
            position: absolute;
            top: 75%;
            font-size: 18px;
        }

        .double-btn {
            width: 311px;
            /*a:nth-child(1) {
                margin-left: 75px;
                padding-right: 75px;
            }*/
        }


        .single-btn a {
            margin-left: 135px;
        }

        .btn-cancel, .btn-confirm{
            color: #538DFF;
        }

        .btn-cancel.co_red, .btn-confirm.co_red{
            color: #F7534F;
        }
        .a-btn{
          margin-left: 45px;
        }

    }
</style>
